import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useAddNewProductMutation, useUpdateProductMutation, useGetProductByIdQuery } from "../features/products/productsApiSlice";
import { validationColors, productCondition, productCategory, productBrand, ROUTES } from "../assets/data";
import upload_icon_1 from "../assets/images/upload-icon-1.png";
import CustomTooltip from "../components/ui/CustomTooltip";
import useAuth from "../hooks/useAuth";
import InputBox from "../components/InputBox";
import DropdownInput from "../components/DropdownInput";
import { addToStore, editInStore, updateStoreAfterAdd, updateStoreAfterEdit, rollbackStore } from "../features/products/productSlice";
import Modal from "../components/Modal";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../components/ui/tooltip";
import { Button } from "../components/ui/button";

import { restrictToParentElement } from "@dnd-kit/modifiers";
import {
  DndContext,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  closestCenter,
} from "@dnd-kit/core";
import { arrayMove, sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import {
  SortableContext,
  horizontalListSortingStrategy,
} from "@dnd-kit/sortable";
import { ProductFormImage } from "../components/ProductFormImage";

const STRING_INPUT_VALIDATOR_REGEX = /^[a-zA-Z0-9&\-' ]{1,20}$/;
const NUMBER_INPUT_VALIDATOR_REGEX = /^[0-9.,]{1,20}$/;
let removedCount = 0, lastRemoved = -1;
let removedImages = [];

const ProductForm = () => {
  const pID = useParams();
  const dispatch =useDispatch();
  const newProduct = pID.id === undefined;
  
  useEffect(() => {
    if(newProduct){
      onClear();
    }
  }, [newProduct]);
  const { data: product, isLoading: infoLoading, isSuccess: infoSuccess } = useGetProductByIdQuery(pID.id);
  const { id } = useAuth();
  // const { refetch } = useGetProductByIdQuery(pID.id);
  
  let pName,
      pBrand,
      pCondition,
      pCategory,
      pPrice,
      pDescription,
      pImages,
      postType = "Sell";

  if(infoSuccess) {
    pName = product.product_name;
    pBrand = product.brand;
    pCondition = product.condition;
    pCategory = product.category;
    pPrice = product.price;
    pDescription = product.description;
    pImages = product.image;
    postType = product.need;
  }

  const [addNewProduct, { isLoading, isSuccess, isError, error }] =
    useAddNewProductMutation();
  const [updateProduct, { isLoading: updateLoading, isSuccess: updateSuccess, isError: updateIsError, error: updateError }] =
    useUpdateProductMutation();
  const navigate = useNavigate();
  const { componentHeight } = useSelector((state) => state?.general);
  const scrollableDivRef = useRef(null);

  const [product_name, setProductName] = useState("");
  const [brand, setBrand] = useState("");
  const [condition, setCondition] = useState("");
  const [category, setCategory] = useState("");
  const [price, setPrice] = useState("");
  const [description, setDescription] = useState("");

  const [productImages, setProductImages] = useState([]);
  const [pOldImages, setPOldImages] = useState([]);
  const [imageKey, setImageKey] = useState(Date.now());

  const [selectedFiles, setSelectedFiles] = useState([]);
  
  const [iOrder, setIOrder] = useState([]);
  const [newOrder, setNewOrder] = useState([]);

  const [postKind, setPostKind] = useState("Sell");

  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {if(!newProduct)setProductName(pName);}, [pName, newProduct]);
  useEffect(() => {if(!newProduct)setBrand(pBrand);}, [pBrand, newProduct]);
  useEffect(() => {if(!newProduct)setCondition(pCondition);}, [pCondition, newProduct]);
  useEffect(() => {if(!newProduct)setCategory(pCategory);}, [pCategory, newProduct]);
  useEffect(() => {if(!newProduct)setPrice(pPrice);}, [pPrice, newProduct]);
  useEffect(() => {if(!newProduct)setDescription(pDescription);}, [pDescription, newProduct]);
  useEffect(() => {
    if (!newProduct && Array.isArray(pImages)) {
      setPOldImages(
        pImages.map((image, index) => ({
          id: `old-${index}`,
          url: image
        }))
      );
    } else {
      setPOldImages([]);
    }
  }, [pImages, newProduct]);
  useEffect(() => {if(!newProduct) setPostKind(postType);}, [postType, newProduct]);


  const [validProductName, setValidProductName] = useState(false);
  const [validBrand, setValidBrand] = useState(false);
  const [validCondition, setValidCondition] = useState(false);
  const [validCategory, setValidCategory] = useState(false);
  const [validPrice, setValidPrice] = useState(false);

  useEffect(() => {
    setValidProductName(STRING_INPUT_VALIDATOR_REGEX.test(product_name));
  }, [product_name]);
  useEffect(() => {
    setValidBrand(STRING_INPUT_VALIDATOR_REGEX.test(brand));
  }, [brand]);
  useEffect(() => {
    setValidCondition(productCondition.includes(condition));
  }, [condition]);
  useEffect(() => {
    setValidCategory(STRING_INPUT_VALIDATOR_REGEX.test(category));
  }, [category]);
  useEffect(() => {
    setValidPrice(NUMBER_INPUT_VALIDATOR_REGEX.test(price));
  }, [price]);

  useEffect(() => {
    console.log(pOldImages);
    setIOrder([])
    pOldImages?.map((image, index) => (
      setIOrder((previousOrder) => {
        if(image.id.startsWith("new")){
          const newOrder = [...previousOrder, Number(image.id.replace("new-", ""))];
          return newOrder;
        }else{
          const newOrder = [...previousOrder, Number(image.id.replace("old-", ""))+10];
          return newOrder;
        }
      })
    ));
  }, [pOldImages]);

  useEffect(() => {
    const newValues = iOrder?.filter(value => value < 10) || [];
    setNewOrder(newValues);
  }, [iOrder]);

  useEffect(() => {
    console.log(iOrder);
  }, [iOrder]);

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  useEffect(() => {
    if (isSuccess) {
      setProductName("");
      setBrand("");
      setCondition("");
      setCategory("");
      setPrice("");
      setDescription("");
      navigate(ROUTES.MY_STORE);
    }
    if (updateSuccess) {
      setProductName("");
      setBrand("");
      setCondition("");
      setCategory("");
      setPrice("");
      setDescription("");
      removedImages = [];
      // refetch();
      navigate(ROUTES.MY_STORE);
    }
  }, [isSuccess, updateSuccess, navigate]);

  const onProductNameChanged = (e) => setProductName(e.target.value);
  const onBrandChanged = (e) => setBrand(e.target.value);
  const onConditionChanged = (e) => setCondition(e.target.value);
  const onCategoryChanged = (e) => setCategory(e.target.value);

  const formatNumber = (number) => {
    const parts = number.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };
  const onPriceChanged = (e) => {
    let rawValue = e.target.value.replace(/,/g, ''); // Remove existing commas
    if (/^[0-9.]*$/.test(rawValue)) { // Allow only numbers and periods
      const formattedValue = formatNumber(rawValue); // Format the number with commas
      setPrice(formattedValue);
    }
  };
  const onDescriptionChanged = (e) => setDescription(e.target.value);

  const handleRemoveOldImage = ({ id, index }) => {
    const updatedImages = [...pOldImages];
    if(id.startsWith("new")){
      setProductImages((prevImages) => {
        const numberPart = Number(id.replace("new-", ""));
        const updatedImages = [...prevImages];
        updatedImages.splice(numberPart, 1);
        setImageKey(Date.now());
        return updatedImages;
      });
    }
    
    if(removedCount === 0 || index < lastRemoved) {
      updatedImages.splice(index, 1);
      lastRemoved = index;
      removedCount += 1;
    }else if (index >= lastRemoved) {
      updatedImages.splice(index, 1);
      index += removedCount;
      lastRemoved = index;
      removedCount += 1;
    }
    if(id.startsWith("old")){
      const numberPart = Number(id.replace("old-", ""));
      removedImages.push(numberPart);
    }
    setPOldImages(updatedImages);
    console.log(updatedImages);
    console.log(pOldImages);
    console.log(productImages);
    console.log(`removed - ${removedImages}`);
  };

  const handleWheel = (event) => {
    const wheelDelta = Math.max(-1, Math.min(1, event.deltaY || -event.detail));
    scrollableDivRef.current.scrollLeft += wheelDelta * 30;
  };
  console.log(newProduct);

  const canSave =
    postKind === "Sell"
      ? [
          validProductName,
          validBrand,
          validCondition,
          validCategory,
          validPrice,
          pOldImages.length,
        ].every(Boolean) && !isLoading
      : newProduct ? [productImages.length].every(Boolean) && !isLoading : !isLoading;

  const onSaveProductClicked = async (e) => {
    e.preventDefault();
    if (canSave) {
      const data = new FormData();
      console.log("here");
      data.append("user", id);
      data.append("product_name", product_name);
      data.append("brand", brand);
      data.append("condition", condition);
      data.append("description", description);
      data.append("cover_detail", description);
      data.append("stock", "2");
      data.append("category", category);
      data.append("price", price);
      data.append("need", postKind);
      // data.append("imageOrder", iOrder);
      
      data.append("imageOrder", JSON.stringify(iOrder));
      
      const tempProduct = {
        product_name,
        brand,
        condition,
        description,
        category,
        price,
        need: postKind,
      };
      
      // Optimistically add to store
      dispatch(addToStore(tempProduct));
      
      try {
        productImages.forEach((file) => {
          data.append("productImages", file);
        });
        
        const serverProduct = await addNewProduct(data);
        
        // Update the store with the server response
        dispatch(updateStoreAfterAdd({
          tempId: tempProduct._id,
          serverProduct
        }));
      } catch (error) {
        console.error("Error adding product:", error);
        dispatch(rollbackStore());
      }
    }
    console.log("he");
  };

  const onUpdateProductClicked = async (e) => {
    e.preventDefault();
    if (canSave) {
      const data = new FormData();
      data.append("id", pID.id);
      data.append("removedImages", removedImages);
      console.log(removedImages);
      data.append("user", id);
      data.append("product_name", product_name);
      data.append("brand", brand);
      data.append("condition", condition);
      data.append("description", description);
      data.append("cover_detail", description);
      data.append("category", category);
      data.append("price", price);
      data.append("need", postType);

      data.append("imageOrder", JSON.stringify(iOrder));

      dispatch(editInStore({ 
        _id: pID.id, 
        product_name: product_name,
        category: category,
        brand: brand,
        description: description,
        price: price
      }));

      try {
        productImages.forEach((file) => {
          data.append("productImages", file);
        });
  
        const serverProduct = await updateProduct(data);

        dispatch(updateStoreAfterEdit({
          _id: pID.id,
          serverProduct
        }));
      } catch (error) {
        console.error("Error adding product:", error);
        dispatch(rollbackStore());
      }
    }
  };

  const onClear = async (e) => {
    setProductName("");
    setBrand("");
    setCondition("");
    setCategory("");
    setPrice("");
    setDescription("");
    setProductImages([]);
    setPOldImages([]);
    setImageKey(Date.now());
  };

  const errClass = isError
    ? `${validationColors.bgInvalid} inline-block text-black p-[0.25em] mb-[0.5em]`
    : "offscreen";
  const validProductNameClass = !validProductName && product_name !== "" ? validationColors.bgInvalid : "";
  const validBrandClass = !validBrand && brand !== "" ? validationColors.bgInvalid : "";
  const validConditionClass = !validCondition && condition !== "" ? validationColors.bgInvalid : "";
  const validCategoryClass = !validCategory && category !== "" ? validationColors.bgInvalid : "";
  const validPriceClass = !validPrice && price !== "" ? validationColors.bgInvalid : "";

  const tooltipText =
    !product_name || !brand || !condition || !category || !price
      ? "Provide all data"
      : canSave ?  "Click to save" : "Provide valid data";

  const [isVisible, setIsVisible] = useState(!canSave);
  useEffect(() => {
    setIsVisible(!canSave);
  }, [canSave]);

  const getTaskPos = (id) => pOldImages.findIndex((pOldImage) => pOldImage.id === id);

  const handleDragEnd = (event) => {
    const { active, over } = event;
  
    if (active && over && active.id !== over.id) {
      setPOldImages((oldImages) => {
        const originalPos = getTaskPos(active.id);
        const newPos = getTaskPos(over.id);
  
        if (originalPos !== -1 && newPos !== -1) {
          return arrayMove(oldImages, originalPos, newPos);
        }
        return oldImages;
      });
    }
  };

  const updateAvatar = (imgSrcList) => {
    setProductImages((prevImages) => {
      const totalImages = [...prevImages, ...imgSrcList].slice(0, 5);
      return totalImages;
    });

    setPOldImages((prevImages) => {
      const totalDisplay = [ ...prevImages, ...imgSrcList?.map((image, index) => ({
        id: `new-${index + newOrder.length}`,
        url: URL.createObjectURL(image)
      }))].slice(0, 5);
      return totalDisplay;
    });
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedFiles([]);
    // Reset the file input
    const fileInput = document.getElementById('imageUpload');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  // let uniqueBrands = productBrand.filter((value, index, self) =>
  //   index === self.indexOf(value)
  // );
  // console.log(productBrand);
  // console.log(uniqueBrands);

  const postKindBtnStyle = "cursor-pointer px-2 py-1 text-center bg-neutral-200";
  const postKindBtnActiveStyle = "cursor-pointer px-2 py-1 text-center bg-gradient-to-r from-blue-500 to-blue-600 text-white";

  return (
    <div
      className="bg-custom-content-bg flex flex-col justify-center items-center overflow-x-hidden"
      style={{ minHeight: `${componentHeight}vh`, height: `${componentHeight}vh`, }}
    >
      <p className={errClass}>{error?.data?.message}</p>
      {/* <p className="w-[40%]">[
        {uniqueBrands.map((option, index) => (
          <span>"{option}", </span>
        ))}
      ]</p> */}
      <form
        className="flex flex-col justify-start items-center relative w-full sm:w-[90%] md:w-[60%] max-w-[1000px] md:min-w-[650px] h-full xs:h-auto xs:max-h-full overflow-y-auto overflow-x-hidden bg-white pb-5 shadow-none md:shadow-custom-shadow-main rounded-none md:rounded-xl short:rounded-none border-none"
        style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
        onSubmit={newProduct? onSaveProductClicked : onUpdateProductClicked}
      >
        <div className="w-full flex bg-neutral-50 justify-between items-end sticky top-0 py-2 px-[4%] z-10">
          <div className="mt-2">
            <span
              className={`${postKind === "Sell" ? postKindBtnActiveStyle : postKindBtnStyle} rounded-l-lg`}
              onClick={() => {setPostKind("Sell");}}
            >Sell</span>
            <span
              className={`${postKind === "request" ? postKindBtnActiveStyle : postKindBtnStyle} rounded-r-lg`}
              onClick={() => {setPostKind("request");}}
            >Request</span>
          </div>
          <span
            onClick={onClear}
            className="material-icons cursor-pointer rounded-[20px] text-neutral-500"
          >
            restart_alt
          </span>
        </div>

        <div className="bg-red-30 mt-4 flex flex-col md:flex-row sm:flex-wrap justify-center items-center gap-GAP-1 w-full relative">
          {/* input boxes for Sell form only */}
          {postKind === "Sell" && (
            <>
              <InputBox usedFor="product_name" boxLabel="Product Name" value={product_name} onChange={onProductNameChanged} validationClass={validProductNameClass} />
              <DropdownInput usedFor="brand" boxLabel="Brand" value={brand} onChange={onBrandChanged} validationClass={validBrandClass} data={productBrand} />
              <DropdownInput usedFor="category" boxLabel="Category" value={category} onChange={onCategoryChanged} validationClass={validCategoryClass} data={productCategory} />
              <InputBox usedFor="price" boxLabel="Price" iconLabel="payments" value={price} onChange={onPriceChanged} validationClass={validPriceClass} />
              <DropdownInput usedFor="condition" boxLabel="Condition" value={condition} onChange={onConditionChanged} validationClass={validConditionClass} data={productCondition} />
              <div className="w-[45%] h-0 hidden md:block"></div>
            </>
          )}

          <div className="relative bg-red-30 w-[91%]">
              <textarea
                name="message"
                rows="3"
                cols="50"
                placeholder="_"
                id="description"
                value={description}
                className={`border border-neutral-400 pt-3 mt-2 outline-none w-full pl-3 rounded-lg text-gray-600`}
                style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
                onChange={onDescriptionChanged}
              ></textarea>
            <label className="absolute top-2 left-4 -translate-y-1/2 text-sm px-2 text-neutral-400 bg-white" htmlFor="description">
              Description
            </label>
          </div>

          {/* Image input container */}
          <div className="flex bg-red-200 justify-start items-center rounded-lg m-0 bg-transparent border border-neutral-400 p-2 text-neutral-600 gap-GAP-1 w-[91%] mb-2 short:max-w-[100%]">
            <div className="flex justify-center items-center border border-solid border-gray-300 rounded-[20px]">
              <input
                type="file"
                accept="image/*"
                multiple
                onChange={(e) => {
                  if (e.target.files.length > 0) {
                    setModalOpen(true);
                    // Pass the selected files to the Modal
                    setSelectedFiles(Array.from(e.target.files));
                    console.log(selectedFiles);
                  }
                }}
                className="hidden"
                id="imageUpload"
              />
              <label htmlFor="imageUpload" className="cursor-pointer">
                <img
                  src={upload_icon_1}
                  className={`shadow-none w-[60px] h-[60px] min-w-[60px] min-h-[60px] p-[8px]`}
                  alt="upload product pics"
                />
              </label>
            </div>
            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragEnd={handleDragEnd}
              modifiers={[restrictToParentElement]}
            >
                <div
                  ref={scrollableDivRef}
                  className="grow h-full bg-red-20 flex justify-start items-center overflow-x-auto gap-GAP-1 px-2"
                  style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
                  onWheel={handleWheel}
                >
                  <SortableContext items={pOldImages.map(img => img.id)} strategy={horizontalListSortingStrategy}>
                    {pOldImages?.map((image, index) => (
                      <ProductFormImage
                        image={image}
                        index={index}
                        key={image.id}  // Use image.id as the key
                        handleRemoveOldImage={handleRemoveOldImage}
                      />
                    ))}
                  </SortableContext>
                </div>
            </DndContext>
          </div>

          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button variant="outline" disabled={!canSave} className="w-[91%] disabled:text-neutral-500 disabled:border-neutral-500 h-[50px] text-[1.2rem] hover:bg-gradient-to-r hover:from-blue-500 hover:to-blue-600 hover:text-white">{newProduct? "Post": "Update"}</Button>
              </TooltipTrigger>
              <TooltipContent>
                <p>{tooltipText}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      </form>
      {modalOpen && (
        <Modal
          initialImage={selectedFiles}
          closeModal={closeModal}
          updateAvatar={updateAvatar}
          useFor="product"
        />
      )}
    </div>
  );
};

export default ProductForm;